/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useGlobalSearch } from "@/global-data";
import { cn } from "@/lib/utils";
import { ReactNode, useState } from "react";

export const DocumentStatistics = ({
  dashboard_details,
  totalItem,
  filter,
  filterRequest,
  showDeletedDocuments,
}: any) => {
  // const { setSearchText } = useGlobalSearch();
  const [showAll] = useState(false);

  // total_processed_files;
  console.log({ dashboard_details });

  const list = ["erp_success", "erp_failed", "snc_success", "on_hold"];

  const MORE_KEY = [
    "duplicate",
    "failed",
    "pending",
    "processed",
    "processing",
    "unsupported",
    "void",
  ];

  console.log();

  const more_data = Object.entries(dashboard_details).reduce(
    (acc: any, curr: any) => {
      if (MORE_KEY.includes(curr[0])) {
        return acc + curr[1];
      }
      return acc;
    },
    0,
  );

  const VISIBLE_COUNT = 4;
  const visibleList = showAll ? list : list.slice(0, VISIBLE_COUNT);
  const isDeletedActive = filter?.is_deleted === true;
  const activeFilter = isDeletedActive ? undefined : filter?.state?.[0];

  // Every tab except "Deleted" lists non-deleted documents
  const withoutDeleted = () => {
    const nextFilter = { ...filter };
    delete nextFilter.is_deleted;
    return nextFilter;
  };

  const handleClick = (prop: string) => {
    if (prop === "") {
      // setFilter((prev: any) => ({ ...prev, state: [] }));
      filterRequest({ ...withoutDeleted(), state: [] });
    } else {
      // setFilter((prev: any) => ({ ...prev, state: [prop] }));
      filterRequest({ ...withoutDeleted(), state: [prop] });
    }
  };

  const isOthersActive = MORE_KEY.some((key) => activeFilter === key);

  return (
    <div className="flex px-2 gap-x-2 gap-y-2 py-1 border-b flex-wrap items-center">
      <DocumentStatisticsItem
        onClick={() => handleClick("")}
        isActive={
          !isDeletedActive &&
          !list.includes(activeFilter) &&
          !MORE_KEY.includes(activeFilter)
        }
        value={"All"}
      >
        {dashboard_details?.total_processed_files || totalItem || 0}
      </DocumentStatisticsItem>

      {visibleList.map((info) => (
        <DocumentStatisticsItem
          key={info}
          value={info}
          isActive={activeFilter === info}
          onClick={() => handleClick(info)}
        >
          {dashboard_details?.[info] || 0}
        </DocumentStatisticsItem>
      ))}

      {showDeletedDocuments ? (
        <DocumentStatisticsItem
          value={"Deleted"}
          isActive={isDeletedActive}
          onClick={() =>
            filterRequest({ ...filter, state: [], is_deleted: true })
          }
        >
          {dashboard_details?.deleted || 0}
        </DocumentStatisticsItem>
      ) : null}

      <div
        className={cn(
          "text-sm border-b-2 px-2 py-1.5 cursor-pointer inline-flex gap-2",
          isOthersActive ? "border-primary" : "border-transparent",
        )}
        onClick={() => filterRequest({ ...withoutDeleted(), state: MORE_KEY })}
      >
        <span
          className={cn(
            "font-medium select-none text-[#374151]",
            isOthersActive ? "text-green-600" : "",
          )}
        >
          Others
        </span>
        <span
          className={cn(
            "rounded-md px-1 py-[1px] text-[13px]",
            isOthersActive ? "bg-primary text-white" : "",
          )}
        >
          {more_data}
        </span>
      </div>

      {/* {!showAll && (
        <span
          className="text-sm text-green-600 cursor-pointer hover:text-green-700 font-medium pr-2 py-1.5 select-none"
          onClick={() => setShowAll(true)}
        >
          +{list.length - VISIBLE_COUNT} more
        </span>
      )}

      {showAll && (
        <span
          className="text-sm text-green-600 cursor-pointer hover:text-green-700 font-medium px-2 py-1.5 select-none"
          onClick={() => setShowAll(false)}
        >
          less
        </span>
      )} */}
    </div>
  );
};

const DocumentStatisticsItem = ({
  value,
  children,
  isActive,
  onClick,
}: {
  children: ReactNode;
  value: string;
  isActive?: boolean;
  onClick: () => void;
}) => {
  const label = typeof value === "string" ? value.replace("_", " ") : value;
  return (
    <div
      className={cn(
        "text-sm border-b-2 px-2 py-1.5 cursor-pointer",
        isActive ? "border-primary" : "border-transparent",
      )}
      onClick={() => onClick()}
    >
      <span
        className={cn(
          "text-[#374151] capitalize",
          isActive ? "text-green-600" : "",
        )}
      >
        {label}
      </span>
      <span
        className={cn(
          "rounded-md ml-2 px-1 py-[1px] text-[13px]",
          isActive ? "bg-primary text-white" : "",
        )}
      >
        {children}
      </span>
    </div>
  );
};
// /* eslint-disable @typescript-eslint/no-explicit-any */
// import { useGlobalSearch } from "@/global-data";
// import { cn } from "@/lib/utils";
// import { ReactNode, useState } from "react";

// export const DocumentStatistics = ({
//   dashboard_details,
//   totalItem,
//   filter,
//   // filterRequest,
//   // setFilter,
// }: any) => {
//   const { search, setSearchText } = useGlobalSearch();
//   const [showAll, setShowAll] = useState(false);

//   const list = [
//     "erp_success",
//     "erp_failed",
//     "snc_success",
//     "on_hold",
//     "duplicate",
//     "failed",
//     "pending",
//     "processed",
//     "processing",
//     "unsupported",
//   ];

//   const VISIBLE_COUNT = 4;
//   const visibleList = showAll ? list : list.slice(0, VISIBLE_COUNT);

//   console.log({ filter });

//   return (
//     <div className="flex px-2 gap-x-2 gap-y-2 py-1 border-b flex-wrap items-center">
//       <DocumentStatisticsItem
//         onClick={() => setSearchText("")}
//         isActive={!list.includes(filter.state[0])}
//         value={"All"}
//       >
//         {totalItem}
//       </DocumentStatisticsItem>

//       {visibleList.map((info) => (
//         <DocumentStatisticsItem
//           key={info}
//           value={info}
//           isActive={search === info}
//           onClick={() => setSearchText(info)}
//         >
//           {dashboard_details?.[info] || 0}
//         </DocumentStatisticsItem>
//       ))}

//       {!showAll && (
//         <span
//           className="text-sm text-green-600 cursor-pointer hover:text-green-700 font-medium pr-2 py-1.5 select-none"
//           onClick={() => setShowAll(true)}
//         >
//           +{list.length - VISIBLE_COUNT} more
//         </span>
//       )}

//       {showAll && (
//         <span
//           className="text-sm text-green-600 cursor-pointer hover:text-green-700 font-medium px-2 py-1.5 select-none"
//           onClick={() => setShowAll(false)}
//         >
//           less
//         </span>
//       )}
//     </div>
//   );
// };

// const DocumentStatisticsItem = ({
//   value,
//   children,
//   isActive,
//   onClick,
// }: {
//   children: ReactNode;
//   value: string;
//   isActive?: boolean;
//   onClick: () => void;
// }) => {
//   const label = typeof value === "string" ? value.replace("_", " ") : value;
//   return (
//     <div
//       className={cn(
//         "text-sm border-b-2 px-2 py-1.5 cursor-pointer",
//         isActive ? "border-primary" : "border-transparent",
//       )}
//       onClick={() => onClick()}
//     >
//       <span
//         className={cn(
//           "text-[#374151] capitalize",
//           isActive ? "text-green-600" : "",
//         )}
//       >
//         {label}
//       </span>
//       <span
//         className={cn(
//           "rounded-md ml-2 px-1 py-[1px] text-[13px]",
//           isActive ? "bg-primary text-white" : "",
//         )}
//       >
//         {children}
//       </span>
//     </div>
//   );
// };
